<template>
    <div>
        <div class="overflowRightNavs" style="width: 600px;">
            <Row class="list_set">
                <Col span="20" offset="1">积分抵现</Col>
                <Col span="3">
                    <i-switch v-model="arrive" @on-change="arriveChange">
                        <span slot="open">On</span>
                        <span slot="close">Off</span>
                    </i-switch>
                </Col>
            </Row>
            <Row class="list_set">
                <Col span="20" offset="1">积分折扣</Col>
                <Col span="3">
                    <i-switch v-model="discount" @on-change="discountChange">
                        <span slot="open">On</span>
                        <span slot="close">Off</span>
                    </i-switch>
                </Col>
            </Row>
            <Divider/>
            <div v-show="isShowIntegral">
                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">客户每消费</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.perConsumption">
                        </Col>
                        <Col span="2">元</Col>
                    </Row>
                </p>
                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">获得积分</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.getIntegral"></Col>
                        <Col span="2">积分</Col>
                    </Row>
                </p>

                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">使用积分</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.useIntegral"></Col>
                        <Col span="2">积分</Col>
                    </Row>
                </p>
                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">抵扣金额</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.deductionMoney">
                        </Col>
                        <Col span="2">元</Col>
                    </Row>
                </p>

            </div>
            <!--积分折扣模块-->
            <div v-show="isShowDiscount">
                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">客户每消费(￥)</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.perConsumption">
                        </Col>
                        <Col span="2">元</Col>
                    </Row>
                </p>
                <p class="integralList">
                    <Row type="flex" class="code-row-bg">
                        <Col span="10" offset="1">获得积分</Col>
                        <Col span="10"><input type="text" class="perConsumption_input" v-model="integral.getIntegral"></Col>
                        <Col span="2">积分</Col>
                    </Row>
                </p>
                <Divider/>
                <!--折扣积分-->
                <div class="integralItem" v-for="(k,v) in discountIntegral">
                    <p class="integralList">
                        <Row type="flex" class="code-row-bg">
                            <Col span="10" offset="1">当客户大于</Col>
                            <Col span="10"><input type="text" class="perConsumption_input" v-model="k.jf"></Col>
                            <Col span="2">积分</Col>
                            <Col span="1"><Icon type="md-close" size="20" color="#5e8bff" @click="delDiscount(v)" /></Col>
                        </Row>
                    </p>
                    <p class="integralList">
                        <Row type="flex" class="code-row-bg">
                            <Col span="10" offset="1">享受折扣%</Col>
                            <Col span="10"><input type="text" class="perConsumption_input" v-model="k.dz">
                            </Col>
                            <Col span="2">%</Col>
                        </Row>
                    </p>
                 </div>
                <Row type="flex" v-if="discountIntegral.length<4">
                    <Col span="24" align="center"><h3 class="finger major" @click="addDiscount()">添加打折区间 <Icon type="ios-add-circle-outline" size="29"  color="#5e8bff"/></h3></Col>
                </Row>
            </div>
            <p style=" width: 50%; margin:30px auto 0" >
                <Button  long type="primary" @click="updateIntegral()">保 存</Button>
            </p>
       </div>

    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                id:'',
                cid: "",
                arrive: false,
                discount: false,
                integral: {
                    perConsumption: '',
                    getIntegral: '',
                    useIntegral: '',
                    deductionMoney: ''
                },
                states:'',
                discountIntegral:[
                    {
                        'jf':'',
                        'dz':'',
                    }
                ],
                isShowIntegral:false,
                isShowDiscount:false,
            }
        },
        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {
                let data= JSON.parse(localStorage.getItem('adminUser'))
                this.cid=data.cid
                this.id=data.id
                this.getIntegralList(this.cid)
            });
        },
        created: function () {
            //DOM更新完之前请求数据

        },
        methods: {

            getIntegralList(id){
                var data = {
                    cid:id
                };
                this.$Api.getIntegralList(data).then(res => {
                    if (res.code == 200) {
                         var getData=res.data[0]
                         this.states = getData.status
                         this.sendStates(this.states)
                         this.integral.perConsumption=getData.consume
                         this.integral.getIntegral=getData.integral
                         this.integral.useIntegral=getData.employ
                         this.integral.deductionMoney=getData.deposit
                         var constmer =   eval("("+getData.constmer+")");
                         this.discountIntegral = constmer
                    } else {
                        this.$Message.warning(res.msg);
                    }
                })
            },
            sendStates(type){
                if(type == 1){
                    this.arrive = true
                    this.discount=false
                    this.isShowIntegral = true
                    this.isShowDiscount = false
                }else if(type == 2){
                    this.arrive = false
                    this.discount=true
                    this.isShowIntegral = false
                    this.isShowDiscount = true
                }else {
                    this.arrive = false
                    this.discount=false
                    this.isShowIntegral = false
                    this.isShowDiscount = false
                }
            },
            //积分抵现
            arriveChange(status) {
                if (status) {
                    this.states=1
                    this.discount = false
                    this.isShowIntegral=true
                    this.isShowDiscount=false
                }else {
                    this.isShowIntegral=false
                    this.states=3
                }
            },
            //积分折扣
            discountChange(status) {
                 if (status) {
                     this.states=2
                     this.arrive=false
                     this.isShowDiscount=true
                     this.isShowIntegral=false
                } else {
                     this.isShowDiscount=false
                     this.states=3
                }
            },
            //添加打折区间
            addDiscount(){
                let integralArr=this.discountIntegral
                if(integralArr.length>=4){
                    this.$Message.warning('最多可设置四个区间值');
                    return
                }
                this.discountIntegral.push({
                    greater:'',
                    enjoyEnjoy:'',
                })

            },
            //删除打折区间
            delDiscount(n){
                let integralArr=this.discountIntegral
                if(integralArr.length==1){
                    this.$Message.warning('至少设置一个区间值');
                    return
                }
                integralArr.splice(n,1)
            },
            //保存积分设置
            updateIntegral() {

                let setList = JSON.stringify(this.discountIntegral)
                let data = {
                    id:this.cid,
                    cid: this.cid,
                    consume:this.integral.perConsumption,
                    integral: this.integral.getIntegral,
                    is: false,
                    employ: this.integral.useIntegral,
                    deposit: 1,
                    isa: true,
                    constmer:setList,
                    discount:'',
                    status: this.states,
                    inputJf:'',
                    valJf: 0,
                };

                this.$Api.updateIntegral(data).then(res => {
                    if (res.code == 200) {
                        this.$Message.success('修改成功');
                        this.getIntegralList(this.cid)
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

        }
    }
</script>


<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }

    .list_set {
        margin: 15px 0;
    }

    .ivu-card-body {
        border-bottom: 1px solid #e8eaec;
    }

    .perConsumption_input {
        width: 90%;
        height: 25px;
        background-color: #e6e6e6;
        border: none;
        padding: 5px;
        text-align: center;
    }

    .integralList {
        margin: 15px 0;
    }
    .integralItem{
        position: relative;

        .delThis{
            position: absolute;
            right: 15px;
            top: 0;
            cursor: pointer;
        }
    }
    .overflowRightNavs{
        position: fixed;
        height: 70%;
        padding: 0px 0 300px;
        overflow: auto;
    }
</style>